import { Component, OnInit, Input } from '@angular/core';
import { TableService } from "../../../services/table.service";

@Component({
  selector: 'app-table-add',
  templateUrl: './table-add.component.html',
  styleUrls: ['./table-add.component.scss']
})
export class TableAddComponent implements OnInit {
  @Input() tournamentId: number = -1;
  @Input() placeId: number = -1;
  @Input() currentTableNumber: number = -1;

  public nextTableNumber: number;

  constructor(
    private tableService: TableService,
  ) { }

  ngOnInit(): void {
    this.nextTableNumber = Number(this.currentTableNumber) + 1;
  }

  createTable() {
    var table = {
      number: this.nextTableNumber,
      place: this.placeId,
      tournament: this.tournamentId,
      is_activate: true
    }
    this.tableService.create(table).subscribe((res) => {
      window.location.reload();
    });
  }

}
